<script>
  import BaseLink from '../BaseLink/BaseLink.svelte';
  import { SPRITESHEET_URL } from '../../utils/constants';
  import { unslugify } from '../../utils/unslugify.ts';

  let {
    dataTestId = 'breadcrumbs-list',
    path,
    crumbsText = undefined,
    queryString = undefined,
    paginationPage = false,
    pharmacyLocationPage = false,
  } = $props();

  const langInPath = path.startsWith('/es/');
  const trimmedPath = path.replace(/(^\/)|(\/$)/g, '').split('/');

  let crumbs = $derived.by(() => {
    if (trimmedPath.length > 1) {
      if (paginationPage) {
        trimmedPath.find((element, index) => {
          if (element === paginationPage) {
            trimmedPath[index] = `${paginationPage}/${trimmedPath[index + 1]}`;
            trimmedPath.splice(index + 1, 1);
          }
        });
      }

      if (pharmacyLocationPage) {
        const addressIndex = !langInPath ? 4 : 5;
        const npiIndex = !langInPath ? 5 : 6;

        trimmedPath[addressIndex] = `${trimmedPath[addressIndex]}/${trimmedPath[npiIndex]}`;
        trimmedPath.splice(npiIndex, 1);
      } else {
        // blog category pages (doesn't have es version)
        if (trimmedPath[0] === 'blog' && trimmedPath[1] === 'categories') {
          trimmedPath[1] = `${trimmedPath[1]}/${trimmedPath[2]}`;
          trimmedPath.splice(2, 1);
        }
      }
      
      if (queryString) {
        trimmedPath.push(queryString);
      }
      
      return trimmedPath;
    }
  });
</script>

{#if (crumbs && crumbs.length > 1 && !langInPath) || (langInPath && crumbs.length > 2)}
  <section data-testid={dataTestId} class="print:hidden w-full bg-white shadow-medium">
    <ol
      class="max-w-6xl mx-auto flex px-4 py-3 lg:py-4 overflow-x-auto whitespace-nowrap"
      itemscope
      itemtype="https://schema.org/BreadcrumbList"
    >
      {#each crumbs as crumb, i (i)}
        {#if (!crumbsText && !langInPath) || (crumbsText && crumbsText.length === crumbs.length)}
          <li
            class="flex"
            itemprop="itemListElement"
            itemscope
            itemtype="https://schema.org/ListItem"
            data-testid="{dataTestId}-item"
          >
            {#if i + 1 !== crumbs.length}
              <BaseLink
                className="text-blue-cerulean font-semibold hover-hover:hover:text-blue-darkish hover-hover:hover:underline active:text-blue-darkish active:underline"
                url={`/${crumbs.slice(0, i + 1).join('/')}`}
                itemprop="item"
              >
                <span itemprop="name">
                  {#if crumbsText}
                    {crumbsText[i]}
                  {:else}
                    {unslugify(crumb)}
                  {/if}
                </span>
                <meta itemprop="position" content={i + 1} />
              </BaseLink>
              <svg role="presentation" class="w-4 h-6 mx-2 text-gray-charcoal fill-current">
                <use xlink:href="{SPRITESHEET_URL}#chevron-right" />
              </svg>
            {:else}
              <span itemprop="name">
                {#if crumbsText}
                  {crumbsText[i]}
                {:else}
                  {unslugify(crumb)}
                {/if}
              </span>
              <meta itemprop="position" content={i + 1} />
            {/if}
          </li>
        {:else if i !== 0}
          <li
            class="flex"
            itemprop="itemListElement"
            itemscope
            itemtype="https://schema.org/ListItem"
            data-testid="{dataTestId}-item"
          >
            {#if i + 1 !== crumbs.length}
              <BaseLink
                className="text-blue-cerulean font-semibold hover-hover:hover:text-blue-darkish hover-hover:hover:underline active:text-blue-darkish active:underline"
                url={`/${crumbs.slice(0, i + 1).join('/')}`}
                itemprop="item"
              >
                <span itemprop="name">
                  {#if crumbsText}
                    {crumbsText[i - 1]}
                  {:else}
                    {unslugify(crumb)}
                  {/if}
                </span>
                <meta itemprop="position" content={i + 1} />
              </BaseLink>
              <svg role="presentation" class="w-4 h-6 mx-2 text-gray-charcoal fill-current">
                <use xlink:href="{SPRITESHEET_URL}#chevron-right" />
              </svg>
            {:else}
              <span itemprop="name">
                {#if crumbsText}
                  {crumbsText[i - 1]}
                {:else}
                  {unslugify(crumb)}
                {/if}
              </span>
              <meta itemprop="position" content={i + 1} />
            {/if}
          </li>
        {/if}
      {/each}
    </ol>
  </section>
{/if}
